module.exports = __webpack_public_path__ + "img/Frontal_op1.8ee1e5a3.jpg";